import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SpInputNumComponent } from '@components/sp-form-controls/sp-input-num/sp-input-num.component';

import type { GridForm } from '@sites/entity-signal-form';

import type { NormalizedGridEntity } from '@web/types';

import { WebGridFormService } from '@web/core/services/web-grid-form.service';

import { SettingsBodyComponent } from '@web/shared/components/web-settings/settings-body/settings-body.component';
import { SettingsBreadcrumbsComponent } from '@web/shared/components/web-settings/settings-breadcrumbs/settings-breadcrumbs.component';

import { AbstractBaseSignalSettingsComponent } from '../abstract-base-settings/abstract-base-signal-settings.component';

@Component({
    selector: 'web-grid-settings',
    templateUrl: './grid-settings.component.html',
    styleUrls: ['./grid-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SettingsBodyComponent, SettingsBreadcrumbsComponent, TooltipModule, TranslatePipe, SpInputNumComponent],
})
export class GridSettingsComponent extends AbstractBaseSignalSettingsComponent implements OnInit {
    public readonly entity = input.required<NormalizedGridEntity>();

    private readonly gridFormService = inject(WebGridFormService);
    private readonly destroyRef = inject(DestroyRef);

    public form!: GridForm;

    constructor() {
        super();
    }

    public ngOnInit(): void {
        this.form = this.gridFormService.getOrCreateScoped(this.entity().id, this.destroyRef);
    }
}
